import { useContext } from 'react';
import { toast } from 'react-toastify';
import { Spinner } from '@ds';
import { Form } from '@ui';
import { AuthContext } from '@lp/core/auth';
import { SchedulerSettingsSubmitRow } from '@lp/features/Scheduler/components';
import { CSSchedulerSettingsInputsFormType } from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/types';
import { CSSchedulerSettingsInputsForm } from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/components';
import {
  csSchedulerSettingsInputsFormSchema,
  getDefaultCSSchedulerInputsValues,
} from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/config';
import { omitKidneyOrgan, omitKidneyOrganRules } from '@lp/features/Scheduler/utils';
import {
  useCSScheduleRegionsQuery,
  useCSScheduleSettingsInputsQuery,
  useCSSetScheduleSettingsInputsMutation,
} from '@/queries/resource/schedule';
import { retrieveUnifiedError } from '@/api/utils';
import { SchedulerPermissions } from '@/permissions';

export const CSSchedulerSettingsInputsTab = () => {
  const { checkPermission } = useContext(AuthContext);
  const { data: schedulerSettingsInputs } = useCSScheduleSettingsInputsQuery();
  const { data: regionList } = useCSScheduleRegionsQuery();
  const { mutateAsync, isPending } = useCSSetScheduleSettingsInputsMutation();

  const hasWritePermissions = checkPermission(SchedulerPermissions.CSSchedulesSettingsInputsWrite);

  const handleSubmit = async (data: CSSchedulerSettingsInputsFormType) => {
    try {
      await mutateAsync({
        ...data,
        exactlyDailyPhoneSupport: omitKidneyOrgan(data.exactlyDailyPhoneSupport),
        perRegions: omitKidneyOrganRules(data.perRegions),
        perHubs: omitKidneyOrganRules(data.perHubs),
      });

      toast.success(`Scheduler Inputs updated successfully`);
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    }
  };

  if (!regionList || !schedulerSettingsInputs) {
    return <Spinner />;
  }

  return (
    <Form<CSSchedulerSettingsInputsFormType>
      defaultValues={getDefaultCSSchedulerInputsValues(regionList, schedulerSettingsInputs)}
      // TMDXLP-14091
      // TODO: Remove after Kidney support
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      schema={csSchedulerSettingsInputsFormSchema}
      onSubmit={handleSubmit}
    >
      <CSSchedulerSettingsInputsForm regions={regionList} isReadOnly={!hasWritePermissions} />
      <SchedulerSettingsSubmitRow backPath="/schedule/cs" isLoading={isPending} isReadOnly={!hasWritePermissions} />
    </Form>
  );
};
